import { Component,  OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { Router, NavigationEnd, ActivatedRoute } from '@angular/router';
import { filter, map, mergeMap } from 'rxjs/operators';
import { DeviceDetectorService } from 'ngx-device-detector';
import { LocalStorageService } from './shared/services/local-storage.service';
import { Title } from '@angular/platform-browser';


@Component({
    selector: 'app-root',
//     template: `
//     <div>
//       <app-counter></app-counter>
//     </div>
//   `,
    templateUrl: './app.component.html'
})
export class AppComponent implements OnInit, OnDestroy {

    subscription: Subscription;

    constructor(private router: Router,    private deviceService:DeviceDetectorService,
        private store: LocalStorageService,
        private activatedRoute: ActivatedRoute,
        private titleService: Title) {
    }

    ngOnInit() {
        this.store.setItem('os',this.deviceService.getDeviceInfo().os);
        this.store.setItem('browser',this.deviceService.getDeviceInfo().browser)
        this.subscription = this.router.events
            .pipe(
                filter(event => event instanceof NavigationEnd)
            )
            .subscribe(() => window.scrollTo(0, 0));

            this.router.events
            .pipe(
              filter(event => event instanceof NavigationEnd), // Only handle navigation end events
              map(() => this.activatedRoute),
              map(route => {
                while (route.firstChild) {
                  route = route.firstChild; // Traverse to the deepest child route
                }
                return route;
              }),
              mergeMap(route => route.data) // Extract the `data` object
            )
            .subscribe(data => {
              if (data['title']) {
                this.titleService.setTitle(data['title']); // Set the browser tab title
              }
            });
    }


    ngOnDestroy() {
        if (this.subscription) {
            this.subscription.unsubscribe();
        }
    }



}